import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=3fd919e2&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
import style0 from "./Chip.vue?vue&type=style&index=0&id=3fd919e2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd919e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd919e2')) {
      api.createRecord('3fd919e2', component.options)
    } else {
      api.reload('3fd919e2', component.options)
    }
    module.hot.accept("./Chip.vue?vue&type=template&id=3fd919e2&scoped=true", function () {
      api.rerender('3fd919e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/Chip.vue"
export default component.exports